import Service from "@/utils/api/service";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { loadMasterData } from "@/utils/loadMasterData";

export default {
  name: "CreateDeliveryFeeBranch",
  data() {
    return {
      isFetching: true,
      isCreating: false,
      body: {
        name: "",
        description: "",
        code: null,
        lat: null,
        lng: null,
      },
      loading: {
        isCreating: false,
        isSearching: false,
      },
      payload: {},
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
  },
  created() {
    setTimeout(async () => {
      await this.getDetail();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListDeliveryFeeBranch",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    isNumber(e) {
      const key = e.key;
      const value = e.target.value;

      // Allow navigation/editing keys
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)
      ) {
        return;
      }

      // Allow shortcuts
      if (
        (e.ctrlKey || e.metaKey) &&
        ["a", "c", "v", "x"].includes(key.toLowerCase())
      ) {
        return;
      }

      // Enforce max 30 chars
      if (value.length >= 30 && !["Backspace", "Delete"].includes(key)) {
        e.preventDefault();
        return;
      }

      // Allow digits
      if (/^\d$/.test(key)) return;

      // Allow one decimal point (not at start, not multiple)
      if (key === "." && value.length > 0 && !value.includes(".")) {
        return;
      }

      // Otherwise block
      e.preventDefault();
    },

    handlePaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");

      // Only allow numbers with optional single decimal
      if (!/^\d+(\.\d+)?$/.test(pasted)) {
        e.preventDefault();
        return;
      }
    },

    async getDetail() {
      this.resetBody();
      this.isFetching = false;
    },

    onSubmit() {
      let validatedMessage = this.validateBody(this.body);

      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.name) {
        return "Branch Name cannot be empty!";
      } else if (typeof data.code === "string") {
        return "Branch Code cannot be empty!";
      } else if (!data.lat) {
        return "Latitude cannot be empty!";
      } else if (!data.lng) {
        return "Logtitude cannot be empty!";
      }

      return "ok";
    },

    transformBody(originalBody) {
      const transformedBody = { ...originalBody };
      transformedBody.lat = Number(transformedBody.lat);
      transformedBody.lng = Number(transformedBody.lng);
      // transformedBody.districtIds = (originalBody.districtIds ?? []).map(
      //   (district) => district.id
      // );
      // transformedBody.customerGroupIds = (
      //   originalBody.customerGroupIds ?? []
      // ).map((group) => group.id);
      // transformedBody.customerIds = (originalBody.customerIds ?? []).map(
      //   (customer) => customer.id
      // );

      return transformedBody;
    },

    onConfirm() {
      Service.createDeliveryFeeBranch(this.transformBody(this.body)).then(
        (response) => {
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.onConfirm();
                }
              });
            } else {
              this.isCreating = false;
              this.$toasted.show(response.message);
            }
          } else {
            this.isCreating = false;
            this.$toasted.show("Delivery Branch has been created.");
            loadMasterData();
            this.goBack();
          }
        }
      );
    },

    resetBody() {
      this.body = {
        name: "",
        description: "",
        code: null,
        lat: null,
        lng: null,
      };
    },
  },
};
